module.exports = __webpack_public_path__ + "img/1440.46dc50fb.jpg";